import { render, staticRenderFns } from "./HeaderChallengeEffects.vue?vue&type=template&id=78880378&scoped=true&"
import script from "./HeaderChallengeEffects.vue?vue&type=script&lang=js&"
export * from "./HeaderChallengeEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78880378",
  null
  
)

export default component.exports